module.exports = __webpack_public_path__ + "media/images/talent/mv-slider02-395fb10d4b87a25bfd2667a377eb3096.png";